export default "__VITE_ASSET__OoU2uDrk__"